import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';

const getRuntimeErrorText = (value) => {
  if (!value) {
    return '';
  }

  if (typeof value === 'string') {
    return value;
  }

  if (value instanceof Error) {
    return [value.message, value.stack].filter(Boolean).join('\n');
  }

  if (typeof value === 'object') {
    return [
      value.message,
      value.filename,
      value.stack,
      value.reason ? getRuntimeErrorText(value.reason) : '',
      value.error ? getRuntimeErrorText(value.error) : '',
    ]
      .filter(Boolean)
      .join('\n');
  }

  return String(value);
};

const isIgnoredInjectedExtensionError = (value) => {
  const text = getRuntimeErrorText(value).toLowerCase();
  const isExtensionInjected =
    text.includes('chrome-extension://') || text.includes('moz-extension://');
  const isKnownExtensionFailure =
    text.includes('origin not allowed') ||
    text.includes('func sseerror not found') ||
    text.includes('sseerror not found');

  return (
    isExtensionInjected &&
    isKnownExtensionFailure
  );
};

const suppressInjectedExtensionErrors = (event) => {
  if (!isIgnoredInjectedExtensionError(event)) {
    return;
  }

  event.preventDefault?.();
  event.stopImmediatePropagation?.();
};

window.addEventListener('error', suppressInjectedExtensionErrors, true);
window.addEventListener('unhandledrejection', suppressInjectedExtensionErrors, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 

     <Provider store={store}>
     <App />
      </Provider>
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
